import React, { useEffect } from "react";
import { Routes, Route, Link, BrowserRouter,useLocation } from "react-router-dom";
import { LoginScreen } from "../auth/LoginScreen";
import ScrollToTop from "../hooks/ScrollToTop";
import { DashboardRouter } from "./DashboardRouter";
import { PrivateRoute } from "./PrivateRoutes";


export const AppRouter = ({ usuario }) => {

  const { pathname } = useLocation();

  useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return (
    <Routes>
    
      <Route path="/login" element={<LoginScreen />}></Route>
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DashboardRouter />
          </PrivateRoute>
        }
      ></Route>
    </Routes>
  );
};
